import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IRemittedRemittanceTransacitonsToolbar {
	onAmountRemittedButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onSaveButtonClickedHandler: () => void
	onSendEmailButtonClickedHandler: () => void
	onForceRemitButtonClickedHandler: () => void
}

export const RemittedRemittanceTransacitonsToolbar: FC<IRemittedRemittanceTransacitonsToolbar> = ({
	onAmountRemittedButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onSaveButtonClickedHandler,
	onSendEmailButtonClickedHandler,
	onForceRemitButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSaveButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Amount Remitted"
					onClickHandler={onAmountRemittedButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					label="Send Emial"
					raised
					onClickHandler={onSendEmailButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				<EnhancedButtonPrimeReact
					label="Force Remit"
					raised
					onClickHandler={onForceRemitButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Toolbar>
		</AppBar>
	);
};
